import React from 'react';
import { NavLink } from 'react-router-dom';
import { useReports } from '../../hooks/useMarketing';

function MarketingSidebar() {
  // Pending-count badge: the 24-hour report SLA queue (draft/generating/failed)
  const { data: reportsData } = useReports();
  const pendingReports = reportsData?.pendingCount || 0;

  return (
    <aside className="mkt-sidebar">
      <div className="mkt-sidebar-brand">
        <h2>MarkoTM</h2>
        <span className="mkt-sidebar-badge">Marketing Ops</span>
      </div>
      <nav className="mkt-sidebar-nav">
        <NavLink
          to="/marketing/pipeline"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">📊</span>
          Pipeline
        </NavLink>
        <NavLink
          to="/marketing/funnel"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">🔻</span>
          Funnel
        </NavLink>
        <NavLink
          to="/marketing/reports"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">📄</span>
          Reports
          {pendingReports > 0 && <span className="mkt-nav-count">{pendingReports}</span>}
        </NavLink>
        <NavLink
          to="/marketing/feedback"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">💬</span>
          Feedback
        </NavLink>
        <NavLink
          to="/marketing/search"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">🔍</span>
          Search
        </NavLink>
        <NavLink
          to="/marketing/assistant"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">🤖</span>
          Ask AI
        </NavLink>
        <NavLink
          to="/marketing/tmwatch"
          className={({ isActive }) => `mkt-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="mkt-nav-icon">®️</span>
          TM Watch
        </NavLink>
      </nav>
      <div className="mkt-sidebar-footer">
        <NavLink to="/attorney" className="mkt-nav-item mkt-nav-secondary">
          <span className="mkt-nav-icon">⚖️</span>
          Attorney Dashboard
        </NavLink>
        <NavLink to="/dashboard" className="mkt-nav-item mkt-nav-secondary">
          <span className="mkt-nav-icon">🏠</span>
          Main App
        </NavLink>
      </div>
    </aside>
  );
}

export default MarketingSidebar;
